import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { Store } from '@ngrx/store';
import { loadFile } from 'src/app/state/actions/upload-file.actions';
import { UploadScreenInfo } from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { getUploadFile } from 'src/app/state/reducers/upload-file.reducer';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private apiSrv: ApiService, private store: Store<any>, private spinner: NgxSpinnerService) {}

  showSpinner() {
    this.spinner.show();
  }

  hideSpinner() {
    this.spinner.hide();
  }

  validateOcr(data: string, dni: string): Observable<any> {
    let body: any = {
      dni: dni,
      file: data,
    };
    return this.apiSrv.post('api/ocr/validate-image', body, { showError: false, ngxSpinner: true });
  }

  saveFiles(upload: UploadScreenInfo) {
    this.store.dispatch(loadFile({ uploadFileInfo: upload }));
  }

  getUploadFile(): Observable<UploadScreenInfo> {
    let resp: UploadScreenInfo = {
      fileDoc: [],
      ciValidationRequired: false,
    };
    this.store.select(getUploadFile).subscribe((data) => {
      resp = data;
    });
    return of(resp);
  }
}
